import { Component } from "react";
import PropTypes from "prop-types";
import getRelativeParent from "./getRelativeParent";
import { getVisibleSelectionRect } from "draft-js";

export default class EditorSelectionCoordinates extends Component {
  static propTypes = {
    ignoreSelectionFocus: PropTypes.bool,
    editorSelection: PropTypes.any.isRequired,
    children: PropTypes.func.isRequired,
  };

  static defaultProps = {
    ignoreSelectionFocus: false,
  };

  state = {
    top: -9999,
    left: -9999,
    visible: false,
  };

  componentDidMount() {
    const { editorSelection } = this.props;

    if (this.innerRef && this.isSelectionVisible(editorSelection)) {
      this.calculateCoordinatesAndSetState(this.innerRef);
    }
  }

  componentWillReceiveProps({ editorSelection, ignoreSelectionFocus }) {
    if (this.isSelectionVisible(editorSelection) || ignoreSelectionFocus) {
      this.calculateCoordinatesAndSetState(this.innerRef);
    } else {
      this.resetCoordinates();
    }
  }

  isSelectionVisible = editorSelection => editorSelection.getHasFocus() && editorSelection.isCollapsed() === false;

  resetCoordinates = () =>
    this.setState({
      top: -9999,
      left: -9999,
      visible: false,
    });

  calculateCoordinatesAndSetState = element => {
    // NOTE: we need to "postpone" the calculation so the whole state gets updated/rendered before
    // we ever get to calculate the actual coordinates of `innerRef`
    this.setState(null, () => {
      const relativeParent = getRelativeParent(element.parentElement);
      const elementHeight = element.clientHeight;
      const relativeRect = (relativeParent || document.body).getBoundingClientRect();

      const visibleSelectionRect = getVisibleSelectionRect(window);

      if (visibleSelectionRect) {
        this.setState({
          top: visibleSelectionRect.top - relativeRect.top - elementHeight,
          left: visibleSelectionRect.left - relativeRect.left + visibleSelectionRect.width / 2,
          visible: true,
        });
      }
    });
  };

  handleSetRef = element => {
    this.innerRef = element;
  };

  render() {
    const { children } = this.props;
    const { top, left, visible } = this.state;

    return children({
      top,
      left,
      innerRef: this.handleSetRef,
      visible,
    });
  }
}
